import { IonPage } from '@ionic/react'
import { useParams } from 'react-router-dom'

import { useGetUnitScheduleds } from '@apps-common/apis/portal/schedules'
import { useGetUnitGenericDetails } from '@apps-common/apis/portal/unit'
import { Schedules } from '@apps-common/apps/portal/pages/units/pages/manage/pages/schedules/components'
import { PullRefresh } from '@apps-common/components/common'
import { AccountNoTitle, PageTitle } from '@apps-common/components/common/portal-title'
import { ButtonRoundLg } from '@apps-common/components/elements'
import { Header, LayoutContainer, LayoutPadding, VertSpacerXl } from '@apps-common/components/layout'
import { Breadcrumbs, Navbar } from '@apps-common/components/navigation'
import { commonIcons } from '@apps-common/config/icons'
import { UNIT_STATUS_CANCELLED } from '@apps-common/config/unit-filter'
import { ROUTE_UNIT_SCHEDULES } from '@apps-radionet-portal/config/private-routes'
import { useScheduleModifyModal } from './hooks/useScheduleModifyModal'

export const SchedulesPage: React.FC = () => {
  const { status, unitId } = useParams<{ status: string; unitId: string }>()
  const { data: unit, isLoading: unitIsLoading, isError: unitIsError } = useGetUnitGenericDetails({ status, unitId })

  const {
    data: schedules,
    isLoading: schedulesIsLoading,
    isRefetching: schedulesIsRefetching,
    isError: schedulesIsError,
    refetch: schedulesRefetch
  } = useGetUnitScheduleds({ config: { enabled: unitId !== undefined }, unitId })

  const { accountNo, productId } = unit || {}

  const { present } = useScheduleModifyModal({
    status,
    unitId,
    productId: productId || '',
    scheduleId: undefined
  })

  const loading = unitIsLoading || unitIsError || schedulesIsLoading || schedulesIsError

  return (
    <IonPage>
      <Header classes='!max-w-[1200px]'>
        <Navbar showBack transparent icons={[]} />
        <Breadcrumbs route={ROUTE_UNIT_SCHEDULES} />
        <div className='flex items-center justify-between'>
          <PageTitle classes='flex items-center justify-start gap-[10px]'>
            <span className='block'>Control Schedules</span>
            <AccountNoTitle text={`(Acc# ${accountNo})`} />
          </PageTitle>
          <ButtonRoundLg
            type='button'
            loading={loading}
            disabled={loading || status === UNIT_STATUS_CANCELLED.value}
            className='action-success'
            callback={() => present()}
            tooltip={{ id: 'device-schedules-add-new', place: 'bottom', message: 'Add new schedule' }}
          >
            <commonIcons.add className='text-[1.35rem]' />
          </ButtonRoundLg>
        </div>
      </Header>
      <LayoutContainer>
        <LayoutPadding classes='pt-[20px] md:pt-[20px]'>
          <PullRefresh loading={schedulesIsRefetching} callback={() => schedulesRefetch()} />
          <Schedules status={status} unitId={unitId} productId={productId || ''} loading={loading} data={schedules || []} />
        </LayoutPadding>
        <VertSpacerXl />
      </LayoutContainer>
    </IonPage>
  )
}
